// store.js
import { readable, writable } from 'svelte/store';
import { db } from "../etc/firebase.js"
export const current_path = writable("/")

export const selectedLanguage = writable("TW")

export const newsListStore = writable(localStorage.getItem("newsListStore") );
newsListStore.subscribe(val => localStorage.setItem("newsListStore", val));

export const guaRecordStore = writable(localStorage.getItem("guaRecordStore") );
guaRecordStore.subscribe(val => localStorage.setItem("guaRecordStore", val));

export const userGuaCount = writable(localStorage.getItem("userGuaCount") );
userGuaCount.subscribe(val => localStorage.setItem("userGuaCount", val));

// export const userSessionStore = writable(localStorage.getItem("userSessionStore" || 
// {
//     isLogin: false,
//     isExpire: true,
//     isNextDay: false,
//     guaCount: 0
//   }
// ) );
// userSessionStore.subscribe(val => localStorage.setItem("userSessionStore", val));

//const store = writable(localStorage.getItem("store") || "");
//store.subscribe(val => localStorage.setItem("store", val));

export const userStore = writable({
  userInfo: {},
//  guaRecords: [],
//  newsList: [],
  isLogin: false,
  isExpire: true,
  isNextDay: false,
 // guaCount: 0
})

// Update guaRecordStore (localStorage)
export function updateGuaRecordStore(firebaseUid) {
 // console.log("@ store function: Updatng GuaRecordStore for UID: " + firebaseUid)

  let guaRecords = []
  let guaCount = 0
  db.collection("guaRecords")
    .where("firebaseUid", "==", firebaseUid)
    .get()
    .then((querySnapshot) => {
      guaCount = 0
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        guaCount++
        let tmpArray = doc.data()
        tmpArray.show = true
        tmpArray.id = doc.id
        guaRecords.push(tmpArray)
      })
      // sort the guaRecords per recordDT as default sort.
      //  console.log("@ Record: before sort guaRecords = ", guaRecords)
      guaRecords.sort((a, b) => (a.recordDT < b.recordDT ? 1 : -1))
      //  console.log("@ Record: after sort guaRecords = ", guaRecords)

      // $userStore.guaCount = guaCount
      // $userStore.guaRecords = [...guaRecords]
      guaRecordStore = JSON.stringify(guaRecords)
      $userGuaCount = guaCount
      console.log(
        "@ Record: guaCount in $userGuaCount is updated = " + userGuaCount
      )
      // console.log(
      //   "@ Record: $userStore.guaRecords = ",
      //   $userStore.guaRecords
      // )
      console.log(
        "@ Record: +++ the refreshed JSON.parse($guaRecordStore) = ",
        JSON.parse(guaRecordStore)
      )
    })
    .catch(function (error) {
      console.log("@ Record: Error getting guaRecords documents: ", error)
    })
}




